import { NavLink, Outlet } from "react-router-dom";
import { Wallet } from "lucide-react";

const TABS = [
  { to: "/pillar/finance/assets", label: "Summary", end: true },
  { to: "/pillar/finance/assets/crypto", label: "Crypto" },
  { to: "/pillar/finance/assets/stocks", label: "Stocks" },
  { to: "/pillar/finance/assets/commodities", label: "Commodities" },
  { to: "/pillar/finance/assets/housing", label: "Housing" },
  { to: "/pillar/finance/assets/cash", label: "Cash" },
  { to: "/pillar/finance/assets/other", label: "Other" },
  { to: "/pillar/finance/assets/settings", label: "Settings" },
];

export default function AssetsLayout() {
  return (
    <div className="px-5 md:px-8 py-8 max-w-[1500px]">
      <div className="flex items-center gap-2 mb-1">
        <span className="w-3 h-3 rounded-full" style={{ backgroundColor: "#9DB7C5" }} />
        <span className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">Finance</span>
      </div>
      <h1 className="font-serif text-3xl md:text-4xl text-foreground flex items-center gap-3 mb-6">
        <Wallet className="w-7 h-7 text-muted-foreground" strokeWidth={1.5} /> Asset Management
      </h1>

      <nav className="flex gap-1 overflow-x-auto quiet-scroll border-b border-border mb-8" data-testid="assets-tabs">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            data-testid={`assets-tab-${t.label.toLowerCase()}`}
            className={({ isActive }) =>
              `px-3.5 py-2.5 text-sm whitespace-nowrap border-b-2 -mb-px transition-colors duration-200 ${
                isActive
                  ? "border-foreground text-foreground font-medium"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
